var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smsc-col__item flex-grow-0",class:("mt-" + _vm.mt),style:({ 'flex-basis': ((100 / _vm.colQuantity) + "%") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }